/**
 * The console's modules, in the order their menu areas appear
 * (core/js/modules.js). A module merging in is a file beside this one and a
 * line here.
 */
import communities from './communities.js';
import palette from './palette.js';
import config from './config.js';

export default [communities, palette, config];
